import React from 'react';
import { graphql } from 'gatsby';
import { FeefoCarousel as FeefoCarouselComponent } from '../../../feefoCarousel/FeefoCarousel';

export const FeefoCarousel = ({ data, ...rest }) => (
  <FeefoCarouselComponent
    reviews={data?.reviews?.sort(
      (a, b) => new Date(b.reviewDate) - new Date(a.reviewDate)
    )}
  />
);

export const FeefoCarouselQuery = graphql`
  fragment FeefoCarousel on UMBRACO_FeefoCarouselComponentType {
    reviews {
      reviewDate
      reviewText
      starCount
      title
      customerName
    }
  }
`;
